<template lang="pug">
  .fileupload
    form(enctype="multipart/form-data")
      input.fileinput-file(name="file" type="file" ref="fileinputref" @change="onSelect")
      .fileinputbutton
        .flex-grid
          .choose-button(@click="$refs.fileinputref.click()")
            Button.fileinput-button(v-if="choose_text" type="m0") {{ choose_text }}
            Button.fileinput-button(v-else type="m0") {{ $t('interface.choose_file') }}
          .uploader-chosen(v-if="file.name")
            Button.fileinput-button(type="m0 success") {{ $t('interface.chosen') }} {{ file.name }}
          .remove-button(v-if="file.name" @click="removeFile")
            Button.fileinput-button(type="m0 primary")
  
</template>

<script>
  // import UploadService from '@/services/upload';
  // import api from '@/services/api'

  export default {
    data: function() {
      return {
        file: "",
        message: ""
      }
    },
    props: ['choose_text'],
    methods: {
      removeFile() {
        this.file = '';
        this.$refs.fileinputref.value = null;
        this.$emit('removedFile');
      },
      onSelect() {
        this.file = this.$refs.fileinputref.files[0];
        this.$emit('input', this.file);
      }
    }
  }
</script>

<style lang="scss">
  .fileupload {
    input.fileinput-file {
      margin:0;
      padding:0;
      font-size:0.1px;
      opacity:0;
      height:0;
    }
    .remove-button {
      max-width:53px;
      .btn {
        background-image:url('~@/assets/images/cross-white.svg');
        background-repeat:no-repeat;
        background-size:16px;
        background-position:center;
      }
    }
    .uploader-chosen {
      .btn-text {
        font-size:11px;
      }
    }
  }
</style>